export default __webpack_public_path__ + "static/blob-49-3f66480247bb6bc5b94ebb3b18a3d3c3.svg";